import { DCUIContent, DCUITheme } from "@iddataweb/idw-common-ui/types";
import { DCUICaptureStepTypes } from "@enums/dcui-capture-step-types";
import { DCUIThemingTabTypes } from "@enums/dcui-theming-tab-types";
import { PreviewEntityTypes } from "@enums/preview-entity-types";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";
import { DCUIThemingPreviewConfigurationState } from "@idw-types/common/dcui/dcui-theming-preview-configuration-state";
import { DCUIThemingStartPage } from "../dcui-theming-start-page/dcui-theming-start-page";
import { DCUIThemingThemePage } from "../dcui-theming-theme-page/dcui-theming-theme-page";
import { DCUIThemingErrorPage } from "../dcui-theming-error-page/dcui-theming-error-page";
import { DCUIThemingCompletePage } from "../dcui-theming-complete-page/dcui-theming-complete-page";
import { DCUIThemingCaptureStepPage } from "../dcui-theming-capture-step-page/dcui-theming-capture-step-page";
import styles from "./dcui-theming-main-container.less";

type DCUIThemingMainContainerProps = {
    currentTab: DCUIThemingTabTypes;
    stepType?: DCUICaptureStepTypes;
    dcuiContent: DCUIContent;
    dcuiTheme: DCUITheme;
    previewConfigurationState: DCUIThemingPreviewConfigurationState;
    documentCaptureSteps: Array<DCUIThemingStep>;
    previewEntityType: PreviewEntityTypes;
};

export const DCUIThemingMainContainer = (props: DCUIThemingMainContainerProps) => {
    const {
        currentTab,
        stepType,
        dcuiContent,
        dcuiTheme,
        previewConfigurationState,
        documentCaptureSteps,
        previewEntityType
    } = props;

    return (
        <div id={"main-container"} className={styles.dcuiThemingMainContainer}>
            <div id={"form-panel"} className={styles.formPanel}>
                {[DCUIThemingTabTypes.THEME].includes(currentTab) && (
                    <DCUIThemingThemePage dcuiTheme={dcuiTheme} />
                )}
                {[DCUIThemingTabTypes.START_PAGE].includes(currentTab) && (
                    <DCUIThemingStartPage
                        dcuiContent={dcuiContent}
                        captureSteps={documentCaptureSteps}
                        dcuiTheme={dcuiTheme}
                        isStartingCapture={previewConfigurationState.showStartPageInProgress}
                        previewEntityType={previewEntityType}
                    />
                )}
                {[
                    DCUIThemingTabTypes.DL_FRONT,
                    DCUIThemingTabTypes.DL_BACK,
                    DCUIThemingTabTypes.ID_FRONT,
                    DCUIThemingTabTypes.ID_BACK,
                    DCUIThemingTabTypes.SELFIE,
                    DCUIThemingTabTypes.PASSPORT
                ].includes(currentTab) && (
                        <DCUIThemingCaptureStepPage
                            stepType={stepType}
                            dcuiContent={dcuiContent}
                            dcuiTheme={dcuiTheme}
                        />
                    )}
                {[DCUIThemingTabTypes.ERROR].includes(currentTab) && (
                    <DCUIThemingErrorPage dcuiContent={dcuiContent} />
                )}
                {[DCUIThemingTabTypes.CUSTOM_CSS].includes(currentTab) && (
                    <div className={styles.previewContainer}>
                        <span>Preview Not Available</span>
                        <span>CSS can apply to any page. Modify the content here and check other tabs to confirm results.</span>
                    </div>
                )}
                {[DCUIThemingTabTypes.CAPTURE_COMPLETE].includes(currentTab) && (
                    <DCUIThemingCompletePage
                        dcuiContent={dcuiContent}
                        showRedirectMessage={previewConfigurationState.showCompletePageRedirectMessage}
                        showUploadErrorMessage={previewConfigurationState.showCompletePageUploadErrorMessage}
                        showUploadInProgress={previewConfigurationState.showCompletePageUploadInProgress}
                    />
                )}
            </div>
        </div>
    );
};